import {customElement, property} from 'lit/decorators.js';
import {css, CSSResult, html, LitElement, PropertyValues, TemplateResult, unsafeCSS,} from 'lit';
import {consume} from '@lit/context';
import typographyStyles from '../../../styles/responsive-nui-typography.scss';
import {ProductIdentifierContainer, Messages, OpenSizeLayerContainer} from '../../../@types/wishlist.js';
import {i18nContext} from '../../../scripts/context/i18nContext.js';

interface NotificationSubscriptionPayload {
  vertriebsinfoId: string;
  source: string;
}

@customElement('ents-notify-me-button')
export class NotifyMeButton extends LitElement {
  @property({attribute: 'identifier', type: String, reflect: true})
  private identifier: string = '';

  @property({attribute: 'salesinformation-id', type: String, reflect: true})
  private salesinformationId: string = '';

  @property({type: String})
  private additionalInfoForAriaLabel: string = '';

  @property({type: Boolean, reflect: true})
  private trigger: boolean = false;

  @consume({context: i18nContext})
  private messages!: Messages;

  static get styles(): CSSResult {
    return css`${unsafeCSS(typographyStyles)}`;
  }

  private getPayload(): NotificationSubscriptionPayload {
    return {
      vertriebsinfoId: this.salesinformationId,
      source: 'wishlist_cta',
    };
  }

  protected updated(_changedProperties: PropertyValues) {
    super.updated(_changedProperties);

    if (_changedProperties.has('trigger') && this.trigger) {
      this.emitEvent();
      this.trigger = false;
    }
  }

  private emitEvent() {
    if (this.salesinformationId) {
      const payload = this.getPayload();
      document.dispatchEvent(new CustomEvent('pruefen:best:wvb-overlay:open', {detail: payload}));
      this.dispatchEvent(new CustomEvent<ProductIdentifierContainer>('ents:cta-event-emitted', {
        detail: {
          identifier: this.identifier,
        },
        bubbles: true,
        composed: true,
      }));
      this.setAttribute('data-test-ents-notify-me-button-payload-emitted', JSON.stringify(payload));
    } else {
      this.dispatchEvent(new CustomEvent<OpenSizeLayerContainer>('ents:size-layer:open', {
        detail: {
          addToCartAfterSizeSelection: false,
          tracking: {
            context: 'wishlist_cart_size_menu',
          },
        },
        bubbles: true,
        composed: true,
      }));
    }
  }

  protected render(): TemplateResult {
    return html`
      <div class="ents-notifyme-button" @click="${this.emitEvent}" data-test-ents-notify-me-button-shadow>
        <button
          aria-label="${this.messages['ents_wishlist_product_cta_notify']} ${this.additionalInfoForAriaLabel}"
          class="bdk-button"
          type="button"
          variant="primary"
          size="medium"
          full-width
        >
          <span>${this.messages['ents_wishlist_product_cta_notify']}</span>
        </button>
      </div>`;
  }
}
